import backofficeService from '../../api/backoffice'

export default {

  getAccount(id) {
    return backofficeService.Api().get(`api/recurly/account/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSubByAccount(id) {
    return backofficeService.Api().get(`api/recurly/subscriptions/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceByAccount(id) {
    return backofficeService.Api().get(`api/recurly/invoicesByAccount/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoice(id) {
    return backofficeService.Api().get(`api/recurly/invoice/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
